import { isObject, isString } from 'lodash';
import { Quill } from 'react-quill';

const Embed = Quill.import('blots/embed');

export class HashTagBlot extends Embed {
    static create(input: any): any {
        const node = super.create();

        if (isObject(input)) {
            node.originalValue = input;
            node.innerText = (input as any).label;
        } else if (isString(input)) {
            node.innerText = input;
        }
        return node;
    }

    static value(node: any): any {
        return node.innerText;
    }

    static formats(node: any): any {
        let format: any = {};

        if (node.originalValue) {
            format = { ...node.originalValue };
        }
        return format;
    }

    format(name: any, value: any): void {
        if (!this.domNode.originalValue) {
            this.domNode.originalValue = {};
        }
        this.domNode.originalValue[name] = value;
    }
}

HashTagBlot.tagName = 'SPAN';
HashTagBlot.blotName = 'hashtag';
HashTagBlot.className = 'ql-hashtag';
